import { getLocale } from './money';

export function formatDateWithOnlyMonth(d: Date, country: Country) {
    return capitalizeFirstLetter(d.toLocaleString(getLocale(country), { month: 'long' }));
}

export function formatDateWithShortMonthOnly(d: Date, country: Country) {
    return capitalizeFirstLetter(d.toLocaleString(getLocale(country), { month: 'short' }));
}

export function formatDateWithMonthAndYear(d: Date, country: Country) {
    return capitalizeFirstLetter(d.toLocaleString(getLocale(country), { month: 'long', year: 'numeric' }));
}
export function formatTime(d: Date, country: Country) {
    return d.toLocaleString(getLocale(country), { hour: '2-digit', minute: '2-digit', second: '2-digit' });
}

export function formatDate(d: Date, country: Country) {
    switch (country) {
        case 'FI':
            return d.toLocaleString(getLocale(country), { month: 'numeric', year: 'numeric', day: 'numeric' });
        case 'NO':
            return d.toLocaleString(getLocale(country), { month: '2-digit', year: 'numeric', day: '2-digit' });
        case 'SE':
            return d.toLocaleString(getLocale(country), { month: 'numeric', year: 'numeric', day: 'numeric' });
    }
}

function capitalizeFirstLetter(str: string) {
    if (!str) {
        return str;
    }
    if (str.length === 1) {
        return str.charAt(0).toUpperCase();
    }
    return str.charAt(0).toUpperCase() + str.slice(1);
}

export function parseIsoDate(isoDateString: IsoDateString) {
        return new Date(isoDateString);
}
